<template>
  <div>
    <el-container>
      <el-header>
        <div class="head-config">
          <div class="store-box">
            <i class="el-icon-apple"></i>
            <p class="store-name">植萌小店商家端</p>
          </div>
          <div class="user-name-box">
            <i class="el-icon-user"></i>
            <p class="user-name">你好！{{ merchantInfo.username }}</p>
            <el-button @click="outLogin">退出</el-button>
          </div>
        </div>
      </el-header>
      <el-container>
        <el-aside width="200px">
          <el-col :span="24">
            <el-menu
              default-active="2"
              class="el-menu-vertical-demo"
              @select="selectMenu"
            >
              <el-menu-item index="Statistics">
                <i class="el-icon-data-line"></i>
                <span slot="title">数据统计</span>
              </el-menu-item>
              <el-menu-item index="GoodsManage">
                <i class="el-icon-shopping-bag-2"></i>
                <span slot="title">商品管理</span>
              </el-menu-item>
              <el-menu-item index="OrderManage">
                <i class="el-icon-tickets"></i>
                <span slot="title">订单管理</span>
              </el-menu-item>
              <el-menu-item index="StoreManage">
                <i class="el-icon-brush"></i>
                <span slot="title">门店管理</span>
              </el-menu-item>
              <el-menu-item index="ConsumerManage">
                <i class="el-icon-crop"></i>
                <span slot="title">消费者管理</span>
              </el-menu-item>
            </el-menu>
          </el-col>
        </el-aside>
        <el-main>
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "Manage",
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {
    merchantInfo() {
      return JSON.parse(localStorage.getItem("merchantInfo"));
    },
  },
  methods: {
    // 退出登录
    outLogin() {
      localStorage.removeItem("token");
      localStorage.removeItem("merchantInfo");
      this.$router.push({ name: "MerchantLogin" });
      this.$message.success("退出成功！");
    },
    selectMenu(key) {
      // 检查是否已经是目标路由，防止重复导航
      if (this.$route.name !== key) {
        try {
          this.$router.push({ name: key });
        } catch (error) {
          console.error("导航失败:", error);
        }
      } else {
        console.log("已经处于目标路由");
      }
    },
  },
};
</script>

<style scoped>
.el-container {
  height: 100vh;
}

.el-header {
  background-color: #ebf3ff;
  color: #333;
  text-align: center;
  line-height: 60px;
  padding: 0px !important;
}

.el-aside {
  color: #333;
  text-align: left;
}

.el-main {
  background-color: #f7f7f7;
  color: #333;
}

.head-config {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.store-box,
.user-name-box {
  cursor: pointer;
}

.el-icon-apple {
  padding: 0px 9px 0px 24px;
}

.store-name {
  margin: 0px;
  display: inline-block;
  font-weight: 600;
}

.user-name {
  margin: 0px;
  padding: 0px 20px 0px 9px;
  display: inline-block;
}

.el-button {
  margin-right: 20px;
}
</style>
